<template>
  <section class="about" id="about">
    <div class="container">
      <div class="about-header">
        <h2 class="section-title">Qui sommes-nous ?</h2>
        <p class="section-subtitle">Une équipe dévouée à votre réussite financière</p>
      </div>

      <div class="about-content">
        <div class="about-text">
          <h3>Oasis Microfinance : Votre partenaire de confiance depuis 2019</h3>
          <p>
            Basée à Ngaoundéré, Cameroun, Oasis Microfinance s'est imposée comme un acteur majeur
            de l'inclusion financière. Notre mission est de rendre les services financiers accessibles
            à tous, particuliers comme entrepreneurs.
          </p>
          <p>
            Avec plus de 15 000 clients satisfaits et un taux d'approbation de 95%, nous accompagnons
            quotidiennement des centaines de personnes dans la réalisation de leurs projets.
          </p>

          <div class="values">
            <div class="value-item">
              <div class="value-icon">🎯</div>
              <h4>Transparence</h4>
              <p>Aucun frais caché, des conditions claires</p>
            </div>
            <div class="value-item">
              <div class="value-icon">⚡</div>
              <h4>Rapidité</h4>
              <p>Décisions en 24h, déblocage rapide</p>
            </div>
            <div class="value-item">
              <div class="value-icon">🤝</div>
              <h4>Proximité</h4>
              <p>Une équipe à votre écoute</p>
            </div>
          </div>
        </div>

        <div class="about-visual">
          <div class="photo-grid">
            <div class="photo-item large">
              <img src="/tofs_1.jpg" alt="Équipe Oasis Finance" />
              <div class="photo-overlay">
                <span>Notre équipe dévouée</span>
              </div>
            </div>
            <div class="photo-item">
              <img src="/tofs_2.jpg" alt="Bureau Oasis" />
              <div class="photo-overlay">
                <span>Nos locaux</span>
              </div>
            </div>
            <div class="photo-item">
              <img src="/accueil2.jpg" alt="Service client" />
              <div class="photo-overlay">
                <span>Service client</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="team-section">
        <h3 class="team-title">Notre équipe passionnée</h3>
        <div class="team-gallery">
          <div class="team-photo" v-for="(photo, index) in teamPhotos" :key="index">
            <img :src="photo.src" :alt="photo.alt" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  data() {
    return {
      teamPhotos: [
        { src: '/tofs_1.jpg', alt: 'Équipe Oasis 1' },
        { src: '/tofs_2.jpg', alt: 'Équipe Oasis 2' },
        { src: '/tofs_3.jpg', alt: 'Équipe Oasis 3' },
        { src: '/tofs_4.jpg', alt: 'Équipe Oasis 4' },
        { src: '/tofs_5.jpg', alt: 'Bureau Oasis' },
        { src: '/tofs_6.jpg', alt: 'Agence Oasis' }
      ]
    }
  }
}
</script>

<style scoped>
.about {
  padding: 6rem 1rem;
  background: linear-gradient(135deg, #f6f9f8 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
}

.about::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(28, 196, 141, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.about-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  color: #0a2e38;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #1cc48d, #0f4c75);
  border-radius: 2px;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #5a6f7b;
  margin-top: 1.5rem;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  margin-bottom: 5rem;
}

.about-text h3 {
  font-size: 1.8rem;
  color: #0a2e38;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.about-text p {
  font-size: 1.1rem;
  color: #5a6f7b;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.values {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 3rem;
}

.value-item {
  text-align: center;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
}

.value-item:hover {
  transform: translateY(-5px);
}

.value-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.value-item h4 {
  font-size: 1.2rem;
  color: #0a2e38;
  margin-bottom: 0.5rem;
}

.value-item p {
  font-size: 0.95rem;
  color: #5a6f7b;
  margin: 0;
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  height: 100%;
}

.photo-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
}

.photo-item:hover {
  transform: scale(1.05);
}

.photo-item.large {
  grid-row: span 2;
}

.photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.photo-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(10, 46, 56, 0.8), transparent);
  padding: 1.5rem;
  color: white;
  font-weight: 600;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.photo-item:hover .photo-overlay {
  opacity: 1;
}

.team-section {
  margin-top: 5rem;
}

.team-title {
  font-size: 2rem;
  color: #0a2e38;
  text-align: center;
  margin-bottom: 3rem;
}

.team-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.team-photo {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  aspect-ratio: 4/3;
}

.team-photo:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

.team-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.team-photo:hover img {
  transform: scale(1.1);
}

@media (max-width: 968px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .values {
    grid-template-columns: 1fr;
  }

  .photo-grid {
    grid-template-columns: 1fr;
    height: auto;
  }

  .photo-item.large {
    grid-row: span 1;
  }

  .team-gallery {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

@media (max-width: 768px) {
  .about {
    padding: 3rem 1rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .about-text h3 {
    font-size: 1.5rem;
  }
}
</style>